/**
 * @file store actions
 * @author wangzhongpeng
 */

 import fetch from '../utils/fetch';

 export default {
   fetchData() {},
   getRegionList(ctx) {
     const { state } = ctx;
     const { rawRegionList } = state;
     if (rawRegionList.length > 0) return;

     fetch
       .get('/windfarm/project/getRegionList', {
         showError: true,
         params: {
           parentId: ''
         }
       })
       .then(res => {
         const { data = {} } = res;
         const { regionList = [] } = data;
         ctx.commit('SET_REGIONLIST', regionList);
       });
   },
   SET_PERMISSION(context, permissionList) {
     // 提交到 mutation 中的 SET_PERMISSION 函数
     context.commit('SET_PERMISSION', permissionList);
   }
 };
